export const LOCATION_TYPES_PICKUP = [
  "Airport",
  "Home",
  "Hospital",
  "Office",
  "Accident site",
  "Public Place",
];

export const LOCATION_TYPES_DROP = [
  "Hotel",
  "Home",
  "Hospital",
  "Office",
  "Guest House",
  "Public Place",
  "Clinic",
];

export const GENERAL_ENQUIRY_FORMS = {
  story: {
    key: "story",
    title: "Guest House/Stay",
    model: "Story",
    savePath: "stay/save",
    termsKey: "terms_condtion",
    fields: [
      { name: "guestHouse_id", label: "Guest House", type: "guesthouse", required: true },
      { name: "guestHouseRoom_id", label: "Room", type: "guesthouse_room", required: true },
      { name: "name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone Number", type: "phone" },
      { name: "passport_number", label: "Passport Number", type: "text" },
      { name: "rooms", label: "Rooms", type: "number" },
      { name: "adults", label: "Adults", type: "number" },
      { name: "children", label: "Children", type: "number" },
      { name: "checkin", label: "Check In", type: "date", required: true },
      { name: "checkout", label: "Check Out", type: "date" },
      {
        name: "payment_mode",
        label: "Payment Mode",
        type: "select",
        options: ["Cash", "Card", "Online", "Credit/Debit Card"],
      },
    ],
  },
  flight: {
    key: "flight",
    title: "Flight Service",
    model: "Flight",
    savePath: "flight/save",
    termsKey: "terms_condtion",
    fields: [
      { name: "first_name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone Number", type: "phone" },
      { name: "passport_number", label: "Passport Number", type: "text" },
      {
        name: "flight_type",
        label: "Flight Type",
        type: "select",
        options: ["One Way", "Round Trip"],
        required: true,
      },
      { name: "from", label: "From", type: "text" },
      { name: "to", label: "To", type: "text" },
      { name: "select_date", label: "Travel Date", type: "date" },
      { name: "arrival_time", label: "Arrival Time", type: "time" },
      { name: "travellers_count", label: "Number of Traveller", type: "number" },
      { name: "services", label: "Services", type: "text", required: true },
    ],
  },
  pickup: {
    key: "pickup",
    title: "Pickup and Drop",
    model: "Pickup",
    savePath: "pickup/save",
    termsKey: "terms_condtion",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone Number", type: "phone" },
      { name: "passport_number", label: "Passport Number", type: "text" },
      { name: "pickup_location", label: "Pickup Address / Location", type: "text", required: true },
      {
        name: "pickup_location_type",
        label: "Pickup Location Type",
        type: "select",
        options: LOCATION_TYPES_PICKUP,
        required: true,
      },
      { name: "pickup_date", label: "Pickup Date", type: "date", required: true },
      { name: "pickup_time", label: "Pickup Time", type: "time", required: true },
      { name: "destination_location", label: "Destination Address / Location", type: "text" },
      {
        name: "destination_location_type",
        label: "Destination Location Type",
        type: "select",
        options: LOCATION_TYPES_DROP,
      },
    ],
  },
  "home-care": {
    key: "home-care",
    title: "Home Care",
    model: "HomeCareRequest",
    savePath: "home-care/save",
    termsKey: "term_condition",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone Number", type: "phone" },
      { name: "passport_number", label: "Passport Number", type: "text" },
      { name: "home_care_type_id", label: "Home Care Type", type: "home_care_type", required: true },
      { name: "home_care_service_id", label: "Home Care Services", type: "home_care_service" },
      { name: "country_id", label: "Country", type: "country_id", required: true },
      { name: "state_id", label: "State", type: "state_id", required: true },
      { name: "city_id", label: "City", type: "city_id", required: true },
      { name: "address", label: "Address", type: "text", required: true },
      { name: "pin_code", label: "Pin Code", type: "text" },
      { name: "location_pin", label: "GPS / Location Pin", type: "text" },
      { name: "contact_number", label: "Contact Number", type: "text" },
      { name: "emergency_contact_number", label: "Emergency Contact Number", type: "text" },
      { name: "start_date", label: "Start Date", type: "date", required: true },
      { name: "end_date", label: "End Date", type: "date", required: true },
    ],
  },
  "test-form": {
    key: "test-form",
    title: "Medical Tests and Scans",
    model: "LabTest",
    savePath: "lab-test/save",
    termsKey: "terms_condtion",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone Number", type: "phone" },
      { name: "passport_number", label: "Passport Number", type: "text" },
      { name: "date", label: "Date", type: "date", required: true },
      { name: "time", label: "Time", type: "time", required: true },
      { name: "country_id", label: "Country", type: "country_id" },
      { name: "state_id", label: "State", type: "state_id" },
      { name: "city_id", label: "City", type: "city_id", required: true },
      { name: "hosp_id", label: "Hospital", type: "hospital" },
      { name: "test_ids", label: "Tests", type: "test_ids", required: true },
      { name: "location_pin", label: "GPS / Location Pin", type: "text" },
      {
        name: "home_sample_collection",
        label: "Home Sample Collection",
        type: "select",
        options: ["Yes", "No"],
      },
    ],
  },
  contact: {
    key: "contact",
    title: "Contact Us",
    model: "PatientContactEnquiry",
    savePath: "contact-enquiry/save",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "country_id", label: "Country", type: "country_id", required: true },
      { name: "phone", label: "Phone", type: "phone" },
      { name: "city", label: "City", type: "text" },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea", required: true },
    ],
  },
};
